let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jTMXJ")).then(() => parcelRequire('7BQsk'));